// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const CheckIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M22.37 4.68c.31.65.04 1.43-.61 1.75-6.78 3.28-10.97 9.3-12.9 12.94-.35.64-1.14.88-1.78.54s-.88-1.14-.54-1.77C8.6 14.26 13.13 7.69 20.62 4.07c.65-.32 1.43-.05 1.75.6" />
      <path
        d="M1.81 12.17c.47-.55 1.3-.62 1.85-.15q3.12 2.64 5.16 6.06c.37.62.17 1.43-.45 1.8s-1.43.17-1.8-.46q-1.8-3.03-4.6-5.4c-.56-.46-.63-1.3-.16-1.85"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default CheckIcon;
